import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, RadioGroupProps } from "@mui/material"

export interface RadioOptShape {
    id: string
    label: string
}

interface NexRadioGroupProps extends RadioGroupProps {
    label?: string
    disabled?: boolean
    options: RadioOptShape[]
    onChange: any
}

export const NexRadioGroup = ({ disabled, label, onChange, options, value }: NexRadioGroupProps) => {
    return (
        <FormControl component="fieldset" disabled={disabled}>
            {label && <FormLabel component="legend">{label}</FormLabel>}
            <RadioGroup
                value={value}
                onChange={(event) => onChange(options.find((opt: RadioOptShape) => opt.id === event.target.value))}
            >
                {options.map((option: RadioOptShape) => (
                    <FormControlLabel key={option.id} label={option.label} value={option.id} control={<Radio />} />
                ))}
            </RadioGroup>
        </FormControl>
    )
}
